export type SemverBumpType = 'major' | 'minor' | 'patch'

const parseSemver = (version: string): [number, number, number] => {
  const clean = version.replace(/^v/, '').split('-')[0].split('+')[0]
  const [major = 0, minor = 0, patch = 0] = clean
    .split('.')
    .map((p) => parseInt(p, 10) || 0)
  return [major, minor, patch]
}

export const isNewerVersion = (
  serverVersion: string,
  clientVersion: string,
): boolean => {
  const [sMaj, sMin, sPatch] = parseSemver(serverVersion)
  const [cMaj, cMin, cPatch] = parseSemver(clientVersion)
  if (sMaj !== cMaj) return sMaj > cMaj
  if (sMin !== cMin) return sMin > cMin
  return sPatch > cPatch
}

export const getSemverBumpType = (
  oldVersion: string,
  newVersion: string,
): SemverBumpType => {
  const [oMaj, oMin] = parseSemver(oldVersion)
  const [nMaj, nMin] = parseSemver(newVersion)
  if (nMaj > oMaj) return 'major'
  if (nMin > oMin) return 'minor'
  return 'patch'
}
